<template>
  <div class="empty-page">
    <figure v-if="image === 'custom'">
      <slot name="image" />
    </figure>
    <div v-else-if="image !== 'nowifi'" class="figure">
      <ck-image :url="`/images/${image}.png`" />
    </div>
    <figure v-else>
      <ck-icon name="ico-custom-no-internet-176px" />
    </figure>
    <div class="text">
      <slot />
    </div>
  </div>
</template>

<script>
import CkImage from '@/components/kit/CkImage'
export default {
  components: {
    CkImage
  },
  props: { image: String }
}
</script>

<style lang="less">
@import (reference) '~@/assets/less/main.less';

.aaltra--layout.has-navigation .navigation + .empty-page {
  margin-top: @space-600;
  padding-top: 0;
  position: relative;
}
</style>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

@empty-page-header-height: 184px;
@empty-page-image-size: 176px;

.empty-page {
  text-align: center;

  figure {
    .lh-display(flex);
    .lh-justify-content(center);
    height: @empty-page-header-height;
    background-color: @white;
    margin-bottom: @empty-page-header-height / 2;
    position: relative;
    img,
    ::v-deep img {
      width: @empty-page-image-size;
      height: @empty-page-image-size;
    }

    .ico {
      position: absolute;
      width: @empty-page-image-size;
      height: @empty-page-image-size;
      margin-top: @empty-page-header-height / 2;
    }
  }

  .figure ::v-deep {
    .el-image {
      .lh-display(flex);
      .lh-justify-content(center);
      position: absolute;
      top: @empty-page-header-height / 2;
      bottom: auto;
      right: auto;
      left: auto;

      .image-slot {
        background-color: @blue-200;
        border-radius: 50%;
        width: @empty-page-image-size;
        height: @empty-page-image-size;

        .ico {
          .fill(@white);
        }
      }
    }
  }

  > .text {
    padding: @space-500;

    ::v-deep > * {
      &:not(:last-child) {
        margin-bottom: @space-m;
      }

      &.btn {
        margin-top: @space-xxl;
      }
    }
  }
}
</style>
